// Drop-in sprite system. Loads PNGs listed in /assets/manifest.json at runtime; the
// renderer uses a sprite when present and falls back to drawn shapes otherwise. Reskin
// by replacing a PNG (same filename) — no code change. See docs/ASSET_AUTHORING.md.

const cache = new Map<string, HTMLImageElement>();

export async function loadSprites(base = '/assets/'): Promise<void> {
  let map: Record<string, string> = {};
  try {
    const res = await fetch(base + 'manifest.json');
    if (res.ok) {
      const data = (await res.json()) as { sprites?: Record<string, string> };
      map = data.sprites ?? {};
    }
  } catch {
    // no manifest → shapes-only fallback
  }

  await Promise.all(
    Object.entries(map).map(
      ([key, file]) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          img.onload = () => {
            cache.set(key, img);
            resolve();
          };
          img.onerror = () => resolve(); // missing/broken asset → fallback
          img.src = base + file;
        }),
    ),
  );
}

/** The loaded image for a key, or null to signal "draw the fallback shape". */
export function sprite(key: string): HTMLImageElement | null {
  return cache.get(key) ?? null;
}
